import script from "./SyncModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./SyncModal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__